/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SalesJsonContent } from './SalesJsonContent';
import {
    SalesJsonContentFromJSON,
    SalesJsonContentFromJSONTyped,
    SalesJsonContentToJSON,
} from './SalesJsonContent';

/**
 * 
 * @export
 * @interface SalesJsonResponse
 */
export interface SalesJsonResponse {
    /**
     * 
     * @type {SalesJsonContent}
     * @memberof SalesJsonResponse
     */
    data?: SalesJsonContent;
}

/**
 * Check if a given object implements the SalesJsonResponse interface.
 */
export function instanceOfSalesJsonResponse(value: object): value is SalesJsonResponse {
    let isInstance = true;

    return isInstance;
}

export function SalesJsonResponseFromJSON(json: any): SalesJsonResponse {
    return SalesJsonResponseFromJSONTyped(json, false);
}

export function SalesJsonResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SalesJsonResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : SalesJsonContentFromJSON(json['data']),
    };
}

export function SalesJsonResponseToJSON(value?: SalesJsonResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': SalesJsonContentToJSON(value.data),
    };
}

